var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[(_vm.title)?_c('div',{staticClass:"page-title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-title__right"},[_vm._t("extral")],2)]):_vm._e(),_c('div',{staticClass:"page-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }